// extracted by mini-css-extract-plugin
module.exports = {"layout":"custom-page_layout__ZT4Wr","withoutPrefooter":"custom-page_withoutPrefooter__V3CPd"};